<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <form @change="logChangeData">
        <div class="setting_content_heading">
          <h2 class="setting_content_title">
            {{ labelProperties.HEAD_TITLE }}
          </h2>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ labelProperties.HEADING_SETTING }}
          </p>
          <p class="setting_unit_explain">
            {{ labelProperties.SUB_HEADING_SETTING }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.LABEL_HEADING_SETTING }}
            </p>
              <div class="setting_unit_form">
                <draggable
                  :list="headingSettings"
                  :group="{
                    name: 'item-job',
                    put: canDragDropHeading && isCanDragToHeading
                  }"
                  draggable=".item"
                  @add="addItemToHeadingBodySetting(1)"
                >
                  <div
                    v-for="(headingSetting, index) in headingSettings"
                    :key="index"
                    class="item"
                  >
                  <template v-if="headingSetting && !headingSetting.itemResourceDeleted">
                    <div
                      @mousedown="isCanDragToBody = false"
                      class="setting_form_wrapper"
                    >
                      <div
                        class="setting_options_category_item"
                        :class="
                          headingSetting.isItemDeletedByMainSystem
                            ? 'item-deleted-setting'
                            : ''
                        "
                      >
                        <svg
                          class="setting_options_category_item_icon"
                          width="10"
                          height="12"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <input
                          class="setting_form_text customize_setting_text"
                          type="text"
                          :placeholder="labelProperties.PLACE_HOLDER"
                          v-model="headingSetting.display_name"
                          readonly
                          :title="
                            headingSetting.isItemDeletedByMainSystem
                              ? labelProperties.MESSAGE_ITEM_DELETE
                              : ''
                          "
                        />
                      </div>
                      <div
                        class="setting_form_wrapper_delete"
                        @click="
                          deleteItemHeadingSetting(
                            headingSettings,
                            index,
                            false,
                            'heading'
                          )
                        "
                        v-if="headingSetting.display_name && index > 0"
                      >
                        <svg
                          width="12"
                          height="12"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fill="#AAA" fill-rule="evenodd">
                            <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                            <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                          </g>
                        </svg>
                      </div>
                      <div
                        class="setting_form_wrapper_close"
                        @click="
                          deleteItemHeadingSetting(
                            headingSettings,
                            index,
                            true,
                            'heading'
                          )
                        "
                      >
                        <svg
                          width="12"
                          height="12"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fill="none" fill-rule="evenodd">
                            <rect fill="#555" width="12" height="12" rx="2" />
                            <g fill="#FFF">
                              <path
                                d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                              />
                              <path
                                d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </template>
                  </div>
                <div
                  slot="footer"
                  class="setting_form_wrapper mt-1"
                  v-show="canDragDropHeading"
                >
                  <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="labelProperties.PLACE_HOLDER"
                    readonly
                  />
                  <div
                    class="setting_form_wrapper_delete"
                    v-if="checkSettingsLength(headingSettings) !== 0"
                    @click="canDragDropHeading = false"
                  >
                    <svg
                      width="12"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#AAA" fill-rule="evenodd">
                        <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                        <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </draggable>
              <div
                class="setting_unit_add"
                v-if="
                  checkSettingsLength(headingSettings) <
                  configProperties.MAX_ITEM
                "
              >
                <a
                  class="setting_unit_add_btn"
                  href="#"
                  @click="canDragDropHeading = true"
                >
                  {{ labelProperties.ADD_ITEM }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ labelProperties.BODY_SETTING }}
          </p>
          <p class="setting_unit_explain">
            {{ labelProperties.SUB_BODY_SETTING }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.LABEL_BODY_SETTING }}
            </p>
            <div class="setting_unit_form">
              <draggable
                :list="bodySettings"
                :group="{ name: 'item-job', put: canDragDropBody &&  isCanDragToBody}"
                draggable=".item"
                @add="addItemToHeadingBodySetting(2)"
              >
                <div
                  v-for="(bodySetting, index) in bodySettings"
                  :key="index"
                  class="item"
                >
                <template v-if="bodySetting && !bodySetting.itemResourceDeleted">
                  <div
                    class="setting_form_wrapper"
                    @mousedown="isCanDragToHeading = false"
                  >
                    <div
                      class="setting_options_category_item"
                      :class="
                        bodySetting.isItemDeletedByMainSystem
                          ? 'item-deleted-setting'
                          : ''
                      "
                    >
                      <svg
                        class="setting_options_category_item_icon"
                        width="10"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="#aaa" fill-rule="evenodd">
                          <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                        </g>
                      </svg>
                      <input
                        class="setting_form_text customize_setting_text"
                        type="text"
                        :placeholder="labelProperties.PLACE_HOLDER"
                        v-model="bodySetting.display_name"
                        readonly
                        :title="
                          bodySetting.isItemDeletedByMainSystem
                            ? labelProperties.MESSAGE_ITEM_DELETE
                            : ''
                        "
                      />
                    </div>
                    <div
                      class="setting_form_wrapper_delete"
                      @click="
                        deleteItemHeadingSetting(
                          bodySettings,
                          index,
                          false,
                          'body'
                        )
                      "
                      v-if="bodySetting.display_name && index > 0"
                    >
                      <svg
                        width="12"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="#AAA" fill-rule="evenodd">
                          <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                          <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                        </g>
                      </svg>
                    </div>
                    <div
                      class="setting_form_wrapper_close"
                      @click="
                        deleteItemHeadingSetting(
                          bodySettings,
                          index,
                           true,
                          'body'
                        )
                      "
                    >
                      <svg
                        width="12"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="none" fill-rule="evenodd">
                          <rect fill="#555" width="12" height="12" rx="2" />
                          <g fill="#FFF">
                            <path
                              d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                            />
                            <path
                              d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </template>
                </div>
               
                <div
                  slot="footer"
                  class="setting_form_wrapper mt-1"
                  v-show="canDragDropBody"
                >
                  <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="labelProperties.PLACE_HOLDER"
                    readonly
                  />
                  <div
                    class="setting_form_wrapper_delete"
                    v-if="checkSettingsLength(bodySettings) !== 0"
                    @click="canDragDropBody = false"
                  >
                    <svg
                      width="12"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#AAA" fill-rule="evenodd">
                        <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                        <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                      </g>
                    </svg>
                  </div>
              </div>
            </draggable>
              <div
                class="setting_unit_add"
                v-if="
                  checkSettingsLength(bodySettings) < configProperties.MAX_ITEM
                "
              >
                <a
                  class="setting_unit_add_btn"
                  href="#"
                  @click="canDragDropBody = true"
                >
                  {{ labelProperties.ADD_ITEM }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div>
      <DragDropComponent
        :groupName="groupName"
        :jobCategories="jobCategories"
        :property="property"
        :resourceFields="resourceFields"
        :useType="useType"
        @updatedProperty="updatedProperty"
        @refreshResourceList="refreshResourceList"
        @getJobResourceFields="getJobResourceFields"
        :idSetScroll="idSetScroll"
        @updateCanDragDrop="updateCanDragDrop"
        :isDispatch="true"
      />
    </div>
  </div>
</template>

<script>
import DragDropComponent from "./DragDropComponent.vue";
import draggable from "vuedraggable";
import HeadlineTextProperties from "../../../../properties/job_screen/headline_setting_tab/headline_setting_labels.json";
import HeadlineConfigProperties from "../../../../properties/job_screen/headline_setting_tab/headline_config.json";
import generalService from "../../../../services/GeneralService";
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";
import * as generalLabels from "../../../../properties/general_page/generalpage-labels.json";
import * as jobSettingProperty from "../../../../properties/job_screen/job-screen.json";

const ITEM_SETTING_IN_HEADING_BODY_TAB = 3;

export default {
  name: "HeadlineTextTab",
  components: {
    DragDropComponent,
    draggable,
  },
  props: [
    "groupName",
    "headingSettings",
    "bodySettings",
    "resourceFields",
    "jobCategories",
    "property",
    "useType",
    "userId",
  ],
  data() {
    return {
      canDragDropHeading: false,
      canDragDropBody: false,
      labelProperties: HeadlineTextProperties,
      configProperties: HeadlineConfigProperties,
      idSetScroll: "menu-search-item-head-line-text",
      log: {
        info: {},
      },
      isCanDragToHeading:true,
      isCanDragToBody:true,
    };
  },
  watch: {
    bodySettings() {
      this.canDragDropBody = this.bodySettings.length === 0;
    },
    headingSettings() {
      this.canDragDropHeading = this.headingSettings.length === 0;
    }
  },
  methods: {
    updateCanDragDrop(){
      this.isCanDragToHeading = true;
      this.isCanDragToBody = true;
    },

    addItemToHeadingBodySetting(type){
      let itemHeadings = [];
      let itemBodys = [];
      if(type === 1){
        this.canDragDropHeading = false;
        this.headingSettings.forEach((item, index) => {
          this.headingSettings[index] = JSON.parse(JSON.stringify(item));
        })
        itemHeadings = this.headingSettings.filter(itemSetting => itemSetting && !itemSetting.itemResourceDeleted);
      }else{
        this.canDragDropBody = false;
        this.bodySettings.forEach((item, index) => {
          this.bodySettings[index] = JSON.parse(JSON.stringify(item));
        })
        itemBodys = this.bodySettings.filter(itemSetting => itemSetting && !itemSetting.itemResourceDeleted);
      }
      
      if(itemHeadings.length > 0){
        this.updateStatusItemUsed(itemHeadings);
      }
      if(itemBodys.length > 0){
        this.updateStatusItemUsed(itemBodys);
      }
      this.$eventBus.$emit("unSaved", true);
    },

    updateStatusItemUsed(items){
      items.filter(item => item && item.name && item.display_name).forEach(item => {
          this.resourceFields.filter((resource) =>resource.name === item.name && resource.display_name === item.display_name )
            .forEach((resource) => {
              if (!resource.isUsed) {
                resource.isUsed = [];
              }
              resource.isUsed.push(ITEM_SETTING_IN_HEADING_BODY_TAB);
            });
        })
      this.$emit("updateResourceField", [...this.resourceFields]);
    },

    async getJobResourceFields() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action =
        "Menu " +
        generalLabels.THIRD_TAB +
        "-Tab " +
        jobSettingProperty.HEADLINE_TEXT_TAB_TITLE +
        "-Click button search " +
        screenLabelsProperties.SEARCH_JOB_LABEL;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("getJobResourceFields", this.log.hash);
    },

    updatedProperty(property) {
      this.$emit("updatedProperty", property);
    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    deleteItemHeadingSetting(settings, index, removeItem, type) {
      this.$eventBus.$emit("unSaved", true);
      settings[index].itemResourceDeleted = true;
      settings = [...settings];
      this.$emit("getJobResourceFields", this.property);
      if (removeItem && type === "heading") {
        this.canDragDropHeading = true;
        return;
      }
      if (removeItem && type === "body") {
        this.canDragDropBody = true;
        return;
      }
      this.checkCanDragDrop();
    },

    checkCanDragDrop() {
      this.canDragDropHeading = this.checkSettingsLength(this.headingSettings) === 0;
      this.canDragDropBody = this.checkSettingsLength(this.bodySettings) === 0;
    },

    checkSettingsLength(array) {
      let length = 0;
      array.forEach((item) => {
        if (!item.itemResourceDeleted) {
          length++;
        }
      });

      return length;
    },

    async refreshResourceList() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action =
        "Menu " +
        generalLabels.THIRD_TAB +
        "-Tab " +
        jobSettingProperty.HEADLINE_TEXT_TAB_TITLE +
        "-Click button" +
        screenLabelsProperties.REFRESH_RESOURCE_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("refreshResourceList", this.log.hash);
    },
  },
};
</script>

<style scoped>
.setting_options_category_item_icon,
.setting_form_text {
  cursor: pointer;
}

.setting_options_category_item {
  padding: 0px 7px !important;
  width: 100% !important;
}

.setting_form_wrapper_delete {
  margin: 8px 0 0 8px !important;
}

.customize_setting_text {
  border: unset !important;
}

.setting_form_wrapper_close {
  top: 55%;
}
</style>
